var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"dense":"","text":"","type":_vm.typestatus}},[_vm._v(_vm._s(_vm.textInfo))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }